import { render } from "./feedbacks.vue?vue&type=template&id=3328aa48&ts=true"
import script from "./feedbacks.vue?vue&type=script&lang=ts"
export * from "./feedbacks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__